var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-header"},[_c('img',{attrs:{"src":require("./img/clock.png"),"alt":""}}),_c('h1',[_vm._t("default")],2),_c('p',[_vm._v("亲爱的小主，我们默认推送时间是每天早上7:00哦~")]),_c('p',[_vm._v("您可以自主选择课程更新提醒推送时间，获取为您量身")]),_c('p',[_vm._v("定制的学习计划~~")])])
}
var staticRenderFns = []

export { render, staticRenderFns }